var map = {
	"./中年女-嘲讽笑1058.wav": "b047",
	"./乐器演奏-二胡与其他乐器.wav": "4d49",
	"./乐器演奏-民族扬琴.wav": "30e9",
	"./医院.wav": "5550",
	"./合唱.wav": "2c68",
	"./哈欠.wav": "b5bc",
	"./城市环境声-体育活动.wav": "d2b3",
	"./夜市.wav": "1bdc",
	"./抽噎声.wav": "300a",
	"./欢呼声.wav": "f768",
	"./特定设备声-家电设备-儿童电动牙刷.wav": "ff59",
	"./笑声.wav": "9fb6",
	"./自然界声音-动物声音-狗叫声.wav": "b288",
	"./自然界声音-地理水文-水流声.wav": "b2882",
	"./超市.wav": "f0fe",
	"./长沙花鼓戏.wav": "d14a",
	"./餐馆.wav": "029e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fe6f";